<!--  -->
<template>
  <div>
    <el-tag
      v-for="itemr,index in arr"
      :key="index"
      style="margin-right:10px"
    >{{ itemr }}</el-tag>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      arr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      this.arr = val
      console.log('val', val)
    }
  }

}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
